<template>
  <div class="wrapper flex page-wrapper">
    <div class="left flexnone">
      <Input placeholder="搜索" @on-change="setTreeData"
             v-model="searchText"
      />
      <Tree :data="treeData" ref="tree" @on-select-change="findList"> </Tree>
    </div>
    <div class="right flexauto page-wrapper2">
      <Button type="primary" class="mb16" @click.stop="toAdd"
              v-p="{api:'menu/add'}"
      >新增菜单</Button>
      <table-list
        title="" :columns="columns" :data="dataTable"
        :loading="loading"
        :total="total"
        :current="current"
        @change-page="changePage"
      ></table-list>
      <AddAndUpdate :n="addN"
                    :parentName="parentName"
                    :parentMenuId="parentMenuId"
                    :appType="appType"
                    :updateId="updateId"
                    @done="init"
                    @close="close"
      ></AddAndUpdate>

    </div>

  </div>
</template>

<script>
  import TableList from "components/TableList/index";
  import AddAndUpdate from './components/AddAndUpdate'
  import { menuTree, menuList, updateMenuStatus,getMenuDetail } from "../../../api/systemmanage";
  import { setTitleAndOthers, setFirstSelected,filterArr, setSelectedFromData } from "../js/systemmanage";

  export default {
    name: "menumanage",
    components:{
      TableList,
      AddAndUpdate
    },
    data () {
      return {
        searchText:'',
        updateId:'',
        updateN:0,
        addN:0,
        parentMenuId:0,
        parentName: '',
        appType:1,
        data: [],
        page:1,
        current: 1,
        pageSize: 10,
        total: 0,
        searchedId: '',
        treeData: [],
        dataTable: [],
        loading: false,
        columns:[
          {
            title:'菜单名称',
            key:'title',
            align:'center',
            width:300,
          },
          {title:' '},
          {
            title:'URL',
            key:'url',
            align:'center',
            width:250,
          },
          {title:' '},
          {
            title:'排序',
            key:'orderNum',
            align:'center',
            width:80,
          },
          {title:' '},
          {
            title:'状态',
            key:'statusName',
            align:'center',
            width:80,
          },
          {title:' '},
          {
            title:'菜单特权',
            key:'categoryName',
            align:'center',
            width:100,
          },
          {title:' '},
          {
            title: '操作',
            key: 'action',
            align: 'center',
            width:100,
            render: (h, params) => {
              let deleteItem = h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'menu/updateMenuStatus'
                    }
                  }
                ],
                style: {
                  marginLeft: '10px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: (params.row['status']  === 0 ? '停用' : '启用') + '菜单',
                      content: (params.row['status']  === 0 ? '确定要停用该菜单吗，停用后该菜单下的所有功能将无法正常使用！' : '确定要启用该菜单吗？'),
                      onOk: () => {
                        let oldStatus = params.row['status'];
                        let status = params.row['status']  === 0 ? 1 : 0;
                        updateMenuStatus({id: params.row['id'], status: status}).then(
                          res => {
                            this.page = 1;
                            this.$Message.success((oldStatus  === 0 ? '停用' : '启用') + '成功');
                            this.pagemenuList(this.searchedId)
                          }
                        ).catch(error => {
                        })
                      }
                    })
                  }
                }
              }, params.row['status']  === 0 ? '停用' : '启用');
              let edit = h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'menu/modify'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.parentMenuId=params.row['parentId'];
                    this.updateId=params.row.id;
                    // if(params.row['isZyu'] === '1'){
                    //   this.appType = 1
                    // } else {
                    //   this.appType = 2
                    // }
                    this.appType=+params.row['isZyu']
                    this.$nextTick(()=>{
                      this.addN++
                    })
                  }
                }
              }, '修改');
              return h('div', {}, [edit, deleteItem])
            }
          },
        ],

      }
    },
    methods:{
      setTreeData: function () {
        if (!this.searchText) {
          this.treeData = this.data
        }
        else {
          this.treeData = filterArr(this.data, this.searchText)
        }
      },
      close(){
        this.updateId='';
        this.parentName='';
        this.parentMenuId=0

      },
      toAdd(){
        let checked = this.$refs['tree'].getSelectedNodes();
        if(checked.length > 0){
          //功能菜单下不能再加菜单
          getMenuDetail({id: checked[0].value}).then(res => {
            if(!res.data){
              return
            }
            if(res.data.type === 1){
              this.$Message.info('功能菜单下不能再加菜单！');
              return
            }
            // if(res.data.isZyu === '1'){
            //   this.appType = 1
            // } else {
            //   this.appType = 2
            // }
            this.appType=+res.data.isZyu
            this.parentName = checked[0].title;
            this.parentMenuId=checked[0].value;
            this.addN++

          }).catch(res=> {
          })

        }
        else {

          //这里写添加根节点的情况
          this.appType = null
          this.addN++

        }

      },
      changePage(n){
        this.current = n;
        this.page = n;
        this.pagemenuList(this.searchedId)
      },
      init(){
        this.menuTree().then(res => {
          let checked = this.$refs['tree'].getSelectedNodes();
          this.findList(checked)
        }).catch().finally(() => {
        })
      },
      menuTree() {
        return menuTree().then(res => {
          if (!res.data) {
            return
          }
          let data = res.data;
          setTitleAndOthers(data);
          if(this.searchedId){
            setSelectedFromData(data, this.searchedId+"")
          }else {
            setFirstSelected(data)
          }
          this.data = data;
          this.treeData = this.data

        }).catch(error => {
        })
      },
      findList(value) {
        if (!value || value.length === 0) {
          return
        }
        this.current = 1;
        this.page = 1;
        this.pagemenuList(value[0].value)
      },
      pagemenuList(value) {
        let params = {
          page: this.page,
          pageSize: this.pageSize,
          id: value
        };
        menuList(params).then(res => {
          if (!res.data) {
            return
          }
          this.dataTable = res.data.rows;
          this.total = res.data.total;
          this.searchedId = value
        }).catch(error => {
        })
      },
    },
    created() {
      this.init()
    }


  }
</script>

<style scoped>
  .wrapper{
    /*display: flex;*/
  }

  .left{
    /*flex: none;*/
    width: 200px;
    /*height: 100%;*/
    height: 80vh;
    box-sizing: border-box;
    overflow: auto;
    padding: 10px;
    border: 1px solid #dcdcdc;
    margin-right: 10px;
    /*background-color: lightgray;*/

  }

</style>
